import { useState, type FormEvent } from "react";
import { Dialog } from "@headlessui/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { routeEndpoints } from "../../routes/routeEndpoints";

interface AddNewOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddNewOrderModal = ({ isOpen, onClose }: AddNewOrderModalProps) => {
  const [orderId, setOrderId] = useState("");
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleClose = () => {
    setOrderId("");
    onClose();
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (orderId.trim()) {
      navigate(`${routeEndpoints.order}?id=${orderId}`);
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
      <div
        className="fixed inset-0 bg-black/45 backdrop-blur-sm"
        aria-hidden="true"
      />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-150 rounded-2xl bg-white md:p-8 p-5 shadow-xl">
          <Dialog.Title className="md:text-2xl text-xl font-semibold text-gray-950 text-center">
            Add New Order
          </Dialog.Title>

          <form onSubmit={handleSubmit} className="mt-6">
            <div className="flex flex-col gap-2">
              <label
                htmlFor="newOrderIdOrLink"
                className="block text-sm/6 font-normal text-gray-950"
              >
                Order ID or link
              </label>
              <input
                id="newOrderIdOrLink"
                type="text"
                autoComplete="off"
                autoFocus
                placeholder="Enter your order ID or link"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                className="block w-full rounded-xl border border-gray-200 px-4 py-3.5 text-sm outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-gray-500"
              />
            </div>

            <div className="mt-6 flex md:gap-5 gap-3">
              <button
                type="button"
                onClick={handleClose}
                className="order-2 md:order-1 h-13 w-full rounded-xl text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="order-1 md:order-2 h-13 w-full flex items-center justify-center gap-2 rounded-xl text-base font-medium text-white bg-blue-600 hover:bg-blue-700 cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed transition-colors"
              >
                Continue
                <ArrowRightIcon className="hidden md:block size-5" />
              </button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default AddNewOrderModal;
